
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'authentication',
	title: 'Authentication'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "api-reference/authentication",
  "id": "api-reference/authentication",
  "isDocsHomePage": false,
  "title": "Authentication",
  "description": "The IOI API uses Basic-Auth for API authentication.",
  "source": "@site/docs/api-reference/authentication.md",
  "sourceDirName": "api-reference",
  "slug": "/api-reference/authentication",
  "permalink": "/docs/api-reference/authentication",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "authentication",
    "title": "Authentication"
  },
  "sidebar": "docs",
  "previous": {
    "title": "Monitor API Traffic",
    "permalink": "/docs/webhooks/monitor-api-traffic"
  },
  "next": {
    "title": "Product and Questions",
    "permalink": "/docs/api-reference/product-and-questions"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [{
  value: 'Say Hello',
  id: 'say-hello',
  children: []
}];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The IOI API uses Basic-Auth for API authentication.
As basic auth uses a secret/key (username/password) combination, these can be created and managed under
`}<inlineCode parentName="p">{`"Dev Tools > API Access Keys"`}</inlineCode>{`. `}</p>
    <p>{`Remember that your API key is a secret! Do not share it with others or expose it in any client-side code (browsers,
apps). Production requests must be routed through your own backend server where your API key can be securely loaded from
an environment variable or key management service.`}</p>
    <p>{`All API requests must include your API key in an `}<inlineCode parentName="p">{`Authorization`}</inlineCode>{` HTTP header as follows:`}</p>
    <p><inlineCode parentName="p">{`Basic <Base64 encoding of Api Key:Secret>`}</inlineCode></p>
    <p>{`After encoding, it should look similar to this:`}</p>
    <p><inlineCode parentName="p">{`Authorization: Basic YmNkODQwM2QtMTVjMC00Njk2LTgxODYtZGI5YjAzYTY2MzY0OnF4T29XS3g5VG5yRnN3dndzWG9mN0laNA==`}</inlineCode></p>
    <h3 {...{
      "id": "say-hello"
    }}>{`Say Hello`}</h3>
    <p>{`Verify that you are able to authenticate by hitting our test endpoint.`}</p>
    <p><strong parentName="p">{`GET:`}</strong>{` `}<inlineCode parentName="p">{`https://api.{ENV}.dais.com/ioi/v3/hello`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-curl"
      }}>{`curl --location --request GET 'https://api.{ENV}.dais.com/ioi/v3/hello' \\
--header 'Authorization: Basic <yourAuthHere>'
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
